import React from 'react';
import { Moon, Sun } from 'lucide-react';

import { useDarkMode } from '@/contexts/DarkModeContext';

type ThemeToggleProps = {
  size?: 'sm' | 'md';
};

const ThemeToggle: React.FC<ThemeToggleProps> = ({ size = 'md' }) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const iconClass = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className="rounded-2xl border border-slate-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 px-2.5 py-1.5 text-sm hover:bg-slate-50 dark:hover:bg-neutral-700 text-neutral-700 dark:text-neutral-300"
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? <Sun className={iconClass} /> : <Moon className={iconClass} />}
    </button>
  );
};

export default ThemeToggle;

